Date.prototype.getYMD = function (delimiter = "-") {
    let month = this.getMonth() + 1;
    let paddedMonth = (month < 10) ? '0' + month.toString() : month.toString();
    let day = this.getDate();
    let paddedDay = (day < 10) ? '0' + day.toString() : day.toString();

    return this.getFullYear() + delimiter + paddedMonth + delimiter + paddedDay;
};

Date.prototype.getHrsMins = function (delimiter = ":") {
    let mins = this.getMinutes();
    let minsPadded = (mins < 10) ? '0' + mins.toString() : mins.toString();
    let hrs = this.getHours();
    let hrsPadded = (hrs < 10) ? '0' + hrs.toString() : hrs.toString();

    return hrsPadded + delimiter + minsPadded;
};

Date.prototype.getWeekNumber = function(){
    var d = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()));
    var dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
    return Math.ceil((((d - yearStart) / 86400000) + 1)/7)
};

window.number_format = function (number, decimals = 2, dec_point = ",", thousands_sep = " ") {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
};

window.number_format_no_zero_decimals = function (number, decimals, dec_point, thousands_sep) {
    let formattedNumber = number_format(number, decimals, dec_point, thousands_sep);
    let removeString = dec_point;

    for (var i = 0; i < decimals; i++) {
        removeString += "0";
    }

    return formattedNumber.replace(removeString, "");
};
